import React from "react";

const ModalFooter = ({ footer, className }) => (
  <div className={"modal-footer " + className}>
    {footer}
  </div>
);

export default ModalFooter;